// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rank-institution .table .record-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.rank-institution .table .record-name img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
.rank-institution .table .record-name p {
  font-weight: bold;
}
.rank-institution .save-button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.rank-institution .save-button button {
  border: none;
  width: 80px;
  height: 40px;
  border-radius: 10px;
}
.rank-institution .save-button button:hover {
  background: var(--benchmarking-color);
  color: white;
  cursor: pointer;
}
.rank-institution .save-button .copy-link {
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-right: 10px;
  border: 1px solid var(--benchmarking-color);
  cursor: pointer;
}
.rank-institution .save-button .copy-link svg path {
  stroke: var(--benchmarking-color);
}
.rank-institution .save-button .copy-link:hover {
  background: var(--benchmarking-color);
}
.rank-institution .save-button .copy-link:hover svg path {
  stroke: white;
}
.rank-institution .filters-institution {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.rank-institution .filters-institution .filters-institution-filter-section {
  display: flex;
  align-items: flex-end;
}
.rank-institution .filters-institution .filters-institution-filter-section .affiliation {
  margin-top: 20px;
}
.rank-institution .filters-institution .filters-institution-filter-section .section-title {
  color: var(--dark-grey);
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px !important;
}
.rank-institution .filters-institution .filters-institution-filter-section .filter-item {
  margin-right: 20px;
}

.scroll-section {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.scroll-section::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroll-section::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}

.scroll-section::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/RankInstitution.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEM;EACE,iBAAA;AAAR;AAIE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAGI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADN;AAGI;EACE,qCAAA;EACA,YAAA;EACA,eAAA;AADN;AAGI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;AADN;AAGQ;EACE,iCAAA;AADV;AAKI;EACE,qCAAA;AAHN;AAKQ;EACE,aAAA;AAHV;AAQE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AANJ;AAWI;EACE,aAAA;EACA,qBAAA;AATN;AAUM;EACE,gBAAA;AARR;AAUM;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AARR;AAUM;EACE,kBAAA;AARR;;AAaA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAVF;;AAYA;EACE,6BAAA;AATF;;AAYA;EACE,UAAA;EACA,6BAAA;AATF;;AAYA;EACE,mBAAA;EACA,mCAAA;AATF","sourcesContent":[".rank-institution {\n  .table {\n    .record-name {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      img {\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        object-fit: cover;\n        margin-right: 10px;\n      }\n      p {\n        font-weight: bold;\n      }\n    }\n  }\n  .save-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    button {\n      border: none;\n      width: 80px;\n      height: 40px;\n      border-radius: 10px;\n    }\n    button:hover {\n      background: var(--benchmarking-color);\n      color: white;\n      cursor: pointer;\n    }\n    .copy-link {\n      width: 50px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 10px;\n      margin-right: 10px;\n      border: 1px solid var(--benchmarking-color);\n      cursor: pointer;\n      svg {\n        path {\n          stroke: var(--benchmarking-color);\n        }\n      }\n    }\n    .copy-link:hover {\n      background: var(--benchmarking-color);\n      svg {\n        path {\n          stroke: white;\n        }\n      }\n    }\n  }\n  .filters-institution {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    .filters-institution-display-filter {\n      \n    }\n    .filters-institution-filter-section {\n      display: flex;\n      align-items: flex-end;\n      .affiliation {\n        margin-top: 20px;\n      }\n      .section-title {\n        color: var(--dark-grey);\n        font-weight: 500;\n        font-size: 16px;\n        margin-bottom: 5px !important;\n      }\n      .filter-item {\n        margin-right: 20px;\n      }\n    }\n  }\n}\n.scroll-section {\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.scroll-section::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.scroll-section::-webkit-scrollbar {\n  width: 5px;\n  background-color: transparent;\n}\n\n.scroll-section::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
